import React, { PureComponent, lazy, Suspense, createContext } from "react";
import { Breadcrumb } from "antd";
import "./index.css";
import Nav from "components/Nav";
import { getCurrentUser } from "utils/storage";
import { Route, Redirect,Link } from "react-router-dom";

export const NavConText = createContext();

//简历管理
const ResumeManage = lazy(() =>
  import("pages/userCenter/personal/resumeManage")
);
//我的投递
const MyDelivery = lazy(() => import("pages/userCenter/personal/myDelivery"));
//职位收藏
const JobCollection = lazy(() =>
  import("pages/userCenter/personal/jobCollection")
);
//课程学习记录
const SubjectStudy = lazy(() => import("./subjectStudy"));
//课程学习记录详情
const SubjectInfo = lazy(() => import("./subjectStudy/components/SubjectInfo"));
//申请培训记录
const ApplyTrainingRecords = lazy(() => import("./applyTrainingRecord"));
//申请培训记录 课程详情
const SubjectDetail = lazy(() =>
  import("./applyTrainingRecord/SubjuectDetail")
);
//个人信息管理
const UserInfo = lazy(() => import("./userInfo/index"));
//异地资金结算列表
const OffSiteTrainingFundSettlement = lazy(() =>
  import("./offSiteTrainingFundSettlement")
);

//异地资金结算 编辑/详情
const OffSiteTrainingFundSettlementDetail = lazy(() =>
  import("./offSiteTrainingFundSettlement/EditOrDetail")
);

//培训记录
const TrainingRecord = lazy(() => import("./skillTrainingRecord/List"));

//培训记录  详情/编辑
const TrainingRecordEditDeatil = lazy(() =>
  import("./skillTrainingRecord/EditDetail")
);

//创业基地入住记录
const EntrepreneurshipBaseRecords = lazy(() =>
  import("pages/userCenter/personal/entrepreneurshipBaseRecords")
);
//创业基地入住详情/编辑
const EntrepreneurshipBaseDetailsOrEdit = lazy(() =>
  import("pages/userCenter/personal/entrepreneurshipBaseDetailsOrEdit")
);
//创业巡诊记录
const BusinessTourRecords = lazy(() =>
  import("pages/userCenter/personal/businessTourRecords")
);
//创业巡诊详情
const BusinessTourDetails = lazy(() =>
  import("pages/userCenter/personal/businessTourDetails/")
);
//职位详情
const JobDetail = lazy(() => import("./myDelivery/JobDetail"));
//创业服务记录
const EntrepreneurshipServiceRecords = lazy(() =>
  import("./entrepreneurshipServiceRecords")
);
//创业服务记录  详情/编辑
const EntrepreneurshipServiceRecordsEditOrDetail = lazy(() =>
  import("./entrepreneurshipServiceRecords/EditOrDetail")
);
//金融产品记录
const FinancialProductRecord = lazy(() => import("./financialProductRecord"));
//金融产品记录 详情/编辑
const FinancialProductRecordEditOrDetail = lazy(() =>
  import("./financialProductRecord/EditOrDetail")
);
//审核管理记录
const AuditManageRecords = lazy(() => import("./auditManageRecords"));
//审核管理记录  审批/查看
const ApplyOrDetail = lazy(() => import("./auditManageRecords/ApplyOrDetail"));

//产品管理记录
const ProductManageRecord = lazy(() => import("./productManageRecord"));
//产品管理记录  查看/编辑
const ProductManageRecordEditOrDetail = lazy(() =>
  import("./productManageRecord/EditOrDetail")
);

//机构信息管理
const MechanismInfoManage = lazy(() => import("./mechanismInfoManage/index"));
//机构课程管理 列表
const MechanismSubjectManage = lazy(() => import("./trainingSubjectManage"));
//机构课程管理  发布线上课程 查看  详情  编辑
const ReleaseOnlineSubject = lazy(() =>
  import("./trainingSubjectManage/ReleaseOnlineSubject")
);
// 发布线下课程 查看  详情  编辑
const ReleaseOfflineSubject = lazy(() =>
  import("./trainingSubjectManage/ReleaseOfflineSubject")
);

// 开班列表
const CreateClassList = lazy(() => import("./createClass"));
// 开班界面
const CreateClass = lazy(() => import("./createClass/CreateClass"));
//课程评价列表
const SubjectEvaluation = lazy(() => import("./subjectEvaluation"));
//课程评价 详情
const SubjectEvaluationDetail = lazy(() =>
  import("./subjectEvaluation/SubjectEvaluationDetail")
);
// 违规学员列表
const ViolationStudent = lazy(() => import("./violationStudent"));
//违规学员  详情
const ViolationStudentDetail = lazy(() => import("./violationStudent/Detail"));

let userType6Route = [
  {
    title: "机构信息管理",
    component: MechanismInfoManage,
    path: "/entrance/personal/mechanismInfoManage",
  },
  {
    title: "培训课程管理",
    component: MechanismSubjectManage,
    path: "/entrance/personal/mechanismSubjectManage",
  },
  {
    title: "编辑课程", //发布线上课程  编辑
    component: ReleaseOnlineSubject,
    path: "/entrance/personal/mechanismSubjectManage/editOnline/:id",
  },
  {
    title: "新增课程", //发布线上课程    添加
    component: ReleaseOnlineSubject,
    path: "/entrance/personal/mechanismSubjectManage/addOnline",
  },
  {
    title: "查看详情", //发布线上课程    查看
    component: ReleaseOnlineSubject,
    path: "/entrance/personal/mechanismSubjectManage/detailOnline/:id",
  },
  {
    title: "编辑课程", //发布线下课程  编辑
    component: ReleaseOfflineSubject,
    path: "/entrance/personal/mechanismSubjectManage/editOffline/:id",
  },
  {
    title: "新增课程", //发布线下课程    添加
    component: ReleaseOfflineSubject,
    path: "/entrance/personal/mechanismSubjectManage/addOffline",
  },
  {
    title: "查看详情", //发布线下课程    查看
    component: ReleaseOfflineSubject,
    path: "/entrance/personal/mechanismSubjectManage/detailOffline/:id",
  },
  {
    title: "培训开班管理",
    component: CreateClassList,
    path: "/entrance/personal/createClass",
  },
  {
    title: "创建班级",
    component: CreateClass,
    path: "/entrance/personal/createClass/add",
  },
  {
    title: "查看详情",
    component: CreateClass,
    path: "/entrance/personal/createClass/detail/:id",
  },
  {
    title: "编辑班级",
    component: CreateClass,
    path: "/entrance/personal/createClass/edit/:id",
  },
  {
    title: "课程评价记录", //课程评价记录 列表
    component: SubjectEvaluation,
    path: "/entrance/personal/subjectEvaluationRecords",
  },
  {
    title: "查看详情", //课程评价记录 详情
    component: SubjectEvaluationDetail,
    path: "/entrance/personal/subjectEvaluationRecords/detail/:id",
  },
  {
    title: "违规学员管理",
    component: ViolationStudent, //违规学员列表
    path: "/entrance/personal/violationStudent",
  },
  {
    title: "查看详情",
    component: ViolationStudentDetail, //违规学员详情
    path: "/entrance/personal/violationStudent/detail/:id",
  },
];

let userType7Route = [
  {
    title: "机构信息管理",
    component: MechanismInfoManage,
    path: "/entrance/personal/mechanismInfoManage",
  },
  {
    title: "金融产品记录",
    component: FinancialProductRecord,
    path: "/entrance/personal/financialProductRecords",
  },
  {
    title: "查看详情", // 金融产品记录 详情
    component: FinancialProductRecordEditOrDetail,
    path: "/entrance/personal/financialProductRecords/detail/:id",
  },
  {
    title: "查看详情", //金融产品记录 编辑
    component: FinancialProductRecordEditOrDetail,
    path: "/entrance/personal/financialProductRecords/edit/:id",
  },
  {
    title: "产品管理记录", //产品管理记录列表
    component: ProductManageRecord,
    path: "/entrance/personal/productManageRecords",
  },
  {
    title: "发布金融产品", //产品管理记录  发布产品 新增
    component: ProductManageRecordEditOrDetail,
    path: "/entrance/personal/productManageRecords/add",
  },
  {
    title: "查看金融产品", //产品管理记录  查看
    component: ProductManageRecordEditOrDetail,
    path: "/entrance/personal/productManageRecords/detail/:id",
  },
  {
    title: "编辑金融产品", //产品管理记录  编辑
    component: ProductManageRecordEditOrDetail,
    path: "/entrance/personal/productManageRecords/edit/:id",
  },
  {
    title: "审核管理记录", //审核管理记录列表
    component: AuditManageRecords,
    path: "/entrance/personal/auditManageRecords",
  },
  {
    title: "申请详情", //审核管理记录  详情
    component: ApplyOrDetail,
    path: "/entrance/personal/auditManageRecords/detail/:id",
  },
  {
    title: "审批管理", //审核管理记录  审批
    component: ApplyOrDetail,
    path: "/entrance/personal/auditManageRecords/apply/:id",
  },
];

let userType5Route = [
  {
    title: "机构信息管理",
    component: MechanismInfoManage,
    path: "/entrance/personal/mechanismInfoManage",
  },
  {
    title: "简历管理",
    component: ResumeManage,
    path: "/entrance/personal/resumeManage",
  },
];

let userType2Route = [
  {
    title: "个人信息管理",
    component: UserInfo,
    path: "/entrance/personal/userInfo",
  },
  {
    title: "简历管理",
    component: ResumeManage,
    path: "/entrance/personal/resumeManage",
  },
  {
    title: "我的投递",
    component: MyDelivery,
    path: "/entrance/personal/myDelivery",
  },
  {
    title: "查看详情", //投递职位详情
    component: JobDetail,
    path: "/entrance/personal/myDelivery/detail/:id",
  },
  {
    title: "职位收藏",
    component: JobCollection,
    path: "/entrance/personal/jobCollection",
  },
  {
    title: "查看详情",
    component: JobDetail,
    path: "/entrance/personal/jobCollection/detail/:id",
  },
  {
    title: "课程学习记录",
    component: SubjectStudy,
    path: "/entrance/personal/courseLearningRecords",
  },
  {
    title: "课程学习记录详情",
    component: SubjectInfo,
    path: "/entrance/personal/courseLearningRecords/detail/:id",
  },
  {
    title: "申请培训记录",
    component: ApplyTrainingRecords,
    path: "/entrance/personal/applyTrainingRecords",
  },
  {
    title: "课程详情",
    component: SubjectDetail,
    path: "/entrance/personal/applyTrainingRecords/detail/:id",
  },
  {
    title: "异地培训资金结算",
    component: OffSiteTrainingFundSettlement,
    path: "/entrance/personal/trainingFundSettlement",
  },
  {
    title: "查看详情", // 异地培训资金结算  详情页
    component: OffSiteTrainingFundSettlementDetail,
    path: "/entrance/personal/trainingFundSettlement/detail/:id",
  },
  {
    title: "查看详情", // 异地培训资金结算  编辑
    component: OffSiteTrainingFundSettlementDetail,
    path: "/entrance/personal/trainingFundSettlement/edit/:id",
  },
  {
    title: "查看详情", //异地培训资金结算  新增页
    component: OffSiteTrainingFundSettlementDetail,
    path: "/entrance/personal/trainingFundSettlement/add",
  },
  {
    title: "技能培训记录",
    component: TrainingRecord,
    path: "/entrance/personal/skillsTrainingRecords",
  },
  {
    title: "查看详情", //技能培训记录查看
    component: TrainingRecordEditDeatil,
    path: "/entrance/personal/skillsTrainingRecords/detail/:id",
  },
  {
    title: "重新上传", //技能培训记录编辑
    component: TrainingRecordEditDeatil,
    path: "/entrance/personal/skillsTrainingRecords/edit/:id",
  },
  {
    title: "创业服务记录",
    component: EntrepreneurshipServiceRecords,
    path: "/entrance/personal/entrepreneurshipServiceRecords",
  },
  {
    title: "查看详情", //创业服务记录查看
    component: EntrepreneurshipServiceRecordsEditOrDetail,
    path: "/entrance/personal/entrepreneurshipServiceRecords/detail/:id",
  },
  {
    title: "查看详情", //创业服务记录编辑
    component: EntrepreneurshipServiceRecordsEditOrDetail,
    path: "/entrance/personal/entrepreneurshipServiceRecords/edit/:id",
  },
  {
    title: "创业基地入住记录",
    component: EntrepreneurshipBaseRecords,
    path: "/entrance/personal/entrepreneurshipBaseRecords",
  },
  {
    title: "查看详情", //创业基地入住查看或编辑
    component: EntrepreneurshipBaseDetailsOrEdit,
    path: "/entrance/personal/entrepreneurshipBaseDetailsOrEdit/:id",
  },
  {
    title: "金融产品记录",
    component: FinancialProductRecord,
    path: "/entrance/personal/financialProductRecords",
  },
  {
    title: "查看详情", // 金融产品记录 详情
    component: FinancialProductRecordEditOrDetail,
    path: "/entrance/personal/financialProductRecords/detail/:id",
  },
  {
    title: "查看详情", //金融产品记录 编辑
    component: FinancialProductRecordEditOrDetail,
    path: "/entrance/personal/financialProductRecords/edit/:id",
  },
  {
    title: "创业巡诊记录",
    component: BusinessTourRecords,
    path: "/entrance/personal/businessTourRecords",
  },
  {
    title: "查看详情", //创业巡诊记录查看详情
    component: BusinessTourDetails,
    path: "/entrance/personal/businessTourDetails",
  },
];
export class Personal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      visible: true, //nav是否展示
      token: null,
      userId: null,
      status: "",
      defaultActive: "1",
      pathMap: {},
      userType: "", //用户类型
      redirectTo: "/entrance/personal/userInfo", //重定向地址
      setDefaultActive: () => {}, //改变侧边导航栏的激活项
    };
  }

  componentWillMount() {
    let userType = getCurrentUser().user_type;
    let pathMap = {};
    let userRouter = [];
    switch (userType) {
      case "2":
        userRouter = userType2Route;
        break;
      case "5":
        userRouter = userType5Route;
        break;
      case "6":
        userRouter = userType6Route;
        break;
      case "7":
        userRouter = userType7Route;
        break;
      default:
        break;
    }
    userRouter.forEach((item, index) => {
      const arr = item.path.split("/");
      arr.splice(0, 3);
      if (!pathMap[arr[0]]) {
        pathMap[arr[0]] = item.title + "," + item.path;
      } else {
        pathMap[arr[1]] = item.title + "," + item.path;
      }
    });
    this.setState({
      pathMap,
    });
  }

  componentDidMount() {
    let userType = getCurrentUser().user_type;
    this.setState({ userType });
    if (userType == 2) {
      this.setState({
        redirectTo: "/entrance/personal/userInfo",
      });
    } else if (userType == 5) {
      this.setState({
        redirectTo: "/entrance/recruitEnterprise/enterpriseInfo",
      });
    } else if (userType == 6) {
      this.setState({
        redirectTo: "/entrance/personal/mechanismInfoManage",
      });
    } else if (userType == 7) {
      this.setState({
        redirectTo: "/entrance/personal/mechanismInfoManage",
      });
    }
  }

  createRoute = () => {
    const arr = [];
    const { userType } = this.state;
    let routeArr = [];
    switch (userType) {
      case "2":
        routeArr = userType2Route;
        break;
      case "5":
        routeArr = userType5Route;
        break;
      case "6":
        routeArr = userType6Route;
        break;
      case "7":
        routeArr = userType7Route;
        break;
      default:
        break;
    }

    routeArr.forEach((item, index) => {
      if (item.children && item.children.length > 0) {
        this.createRoute(item.children);
      }
      arr.push(
        // 子路由需要在父路由的基础上加一级路由  需要加 extra  否则子路由无法匹配
        <Route
          path={item.path}
          exact
          component={item.component}
          key={index + item.path}
        />
      );
    });

    return arr;
  };
  goto = (params) => {
    // window.history.back()
    window.location.reload();
  };
  // 获取实名认证详情
  // getPersonalUserAuthDetail(userId) {
  //     let params = {
  //         userId: userId
  //     };
  //     return Http.post(Request.personalUserAuthDetail(), params, obj => {
  //         console.log('obj', obj);
  //         if (obj.data && obj.code == 200) {
  //             if(obj.data.authenticationStatus == 2){
  //                 this.setState({ status: '审核中' })
  //             }
  //         }
  //     });
  // }

  //侧边导航栏是否显示
  navShow = (value) => {
    this.setState({
      visible: value,
    });
  };
  //传递给nav组件一个方法   nav组件在componentdidmount中调用  传递一个函数作为参数   将参数存进该组件state中   通过context将该方法传递至其他组件调用
  //在点击个人中心时  改变路由以及侧边导航栏的激活项  展示对应的组件
  handleSetDefaultActive = (func) => {
    this.setState({
      setDefaultActive: func,
    });
  };

  render() {
    const { defaultActive, pathMap, visible, redirectTo, setDefaultActive } =
      this.state;
    const { location, history } = this.props;
    const pathArr = location.pathname.split("/");
    pathArr.splice(0, 2);
    const { userType } = this.state;
    let routeArr = [];
    switch (userType) {
      case "2":
        routeArr = userType2Route;
        break;
      case "5":
        routeArr = userType5Route;
        break;
      case "6":
        routeArr = userType6Route;
        break;
      case "7":
        routeArr = userType7Route;
        break;
      default:
        break;
    }
    let title = pathMap[pathArr[1]]?.split(",")[0];
    let titlePath = pathMap[pathArr[1]]?.split(",")[1];
    let childrenTitle = pathMap[pathArr[2]]?.split(",")[0];
    
    // let childrenTitlePath = pathMap[pathArr[2]]?.split(",")[1];
    return (
      <NavConText.Provider
        value={{
          setNavShow: this.navShow,
          setDefaultActive,
        }}
      >
        <div className="userCenter personal">
          <div className="container clear">
            <div className="breadcrumb">
              <Breadcrumb>
                <Breadcrumb.Item href="/entrance/personal">
                  个人中心
                </Breadcrumb.Item>
                <Breadcrumb.Item onClick={childrenTitle?() => history.push(titlePath):()=>{}} style={childrenTitle?{cursor:"pointer"}:{}}>
                  {title}
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                  {childrenTitle}
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <div className="personal_content">
              <Suspense fallback={<div>Loading...</div>}>
                <div
                  className={`left_nav ${
                    visible ? "personal_show_nav" : "personal_hide_nav"
                  }`}
                >
                  <Nav
                    defaultActive={defaultActive}
                    type={1}
                    setDefaultActive={this.handleSetDefaultActive}
                    status={this.state.status}
                    history={this.props.history}
                  />
                </div>
                {this.createRoute()}
                <Redirect from="/entrance/personal" to={redirectTo} />
              </Suspense>
            </div>
          </div>
        </div>
      </NavConText.Provider>
    );
  }
}
